import { Container, TDef } from "components/CustomTableList/components/TableListItem/ListItem/styles";
import { Cell } from "./styles";
import AccordionButton from "components/CustomTableList/components/AccordionButton/AccordionButton";

const TDEF_CONTENT_PROPS = {
    margin: "0",
    className: "small"
};

const TableListItemHeader = ({
    item: {
        student, date,
    }, detailsOfStudentPenaltyIsOpened,
    toggleDetailsOfStudentPenaltyIsOpened
}) => {
    return (
        <Container>
            <TDef>
                <Cell {...TDEF_CONTENT_PROPS} >
                    <h5 title={student.id}>{student.id}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...TDEF_CONTENT_PROPS}>
                    <h5 title={student.name}>{student.name}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...TDEF_CONTENT_PROPS}>
                    <h5 title={date.start}>{date.start}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...TDEF_CONTENT_PROPS}>
                    <h5 title={date.end}>{date.end}</h5>
                </Cell>
            </TDef>
            <TDef>
                <Cell {...TDEF_CONTENT_PROPS}>
                    <AccordionButton 
                        isOpened={detailsOfStudentPenaltyIsOpened}
                        toggleIsOpened={toggleDetailsOfStudentPenaltyIsOpened}/>
                </Cell>
            </TDef>
        </Container>
    );
}

export default TableListItemHeader;